(() => {
  const form = document.querySelector('[data-vecose-rfq]');
  if (!form) return;

  const params = new URLSearchParams(window.location.search);
  const setValue = (name, value) => {
    if (!value) return;
    const field = form.querySelector(`[name="${name}"]`);
    if (field && !field.value) field.value = value;
  };

  const productSelect = form.querySelector('[name="contact[Product]"]');
  const productIdField = form.querySelector('[name="contact[Product ID]"]');
  const productParam = params.get('product') || '';
  const productIdParam = params.get('product_id') || '';
  const productKey = /P002|duo|2-person-infrared/i.test(`${productIdParam} ${productParam}`)
    ? 'P002'
    : /P006|cube-outdoor|outdoor-cube/i.test(`${productIdParam} ${productParam}`)
      ? 'P006'
      : '';
  if (productSelect && productKey) productSelect.value = productKey;
  if (productIdField && productKey) productIdField.value = productKey;
  setValue('contact[UTM source]', params.get('utm_source'));
  setValue('contact[UTM medium]', params.get('utm_medium'));
  setValue('contact[UTM campaign]', params.get('utm_campaign'));
  setValue('contact[UTM content]', params.get('utm_content'));
  setValue('contact[UTM term]', params.get('utm_term'));

  setValue('contact[Source URL]', window.location.href);
  setValue('contact[Referrer]', document.referrer || 'Direct');

  const customerType = form.querySelector('[name="contact[Customer type]"]');
  const subject = form.querySelector('[name="contact[Subject]"]');
  const tags = form.querySelector('[name="contact[tags]"]');

  const updateRouting = () => {
    const type = customerType?.value || 'Unspecified';
    const isBusiness = /Dealer|Distributor|Hotel|Resort|Spa|Gym|Builder|Designer|Developer|Business/i.test(type);
    if (subject) subject.value = isBusiness ? 'VECOSE trade and project RFQ' : 'VECOSE homeowner delivered quote request';
    if (tags) tags.value = isBusiness ? 'rfq,trade-project,new-lead' : 'rfq,homeowner,new-lead';
  };

  customerType?.addEventListener('change', updateRouting);
  productSelect?.addEventListener('change', () => {
    if (productIdField) productIdField.value = /^(P002|P006)$/.test(productSelect.value) ? productSelect.value : '';
  });
  updateRouting();

  form.addEventListener('submit', () => {
    updateRouting();
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'vecose_rfq_submit',
      customer_type: customerType?.value || 'Unspecified',
      product_id: form.querySelector('[name="contact[Product ID]"]')?.value || '',
      country: form.querySelector('[name="contact[Country]"]')?.value || '',
    });
  });
})();
